<template>
  <div class="title">
    <div class="yellow"></div>
    <div class="article_T">
      <h3 class="subtitle" :style="{ fontSize: fontSize.h4 + 'em' }">
        [{{ data.nodeName }}]&ensp;
        {{ data.pageTitle }}
      </h3>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
export default {
  name: "Title",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  display: flex;
  .yellow {
    width: 3%;
    background-color: $main_sec_color;
  }
  .article_T {
    width: 100%;
    background-color: $main_color;
    padding: 20px;
    @include md {
      .subtitle {
        font-size: $p;
      }
    }
    .subtitle {
      color: #fff;
      text-align-last: left;
      margin-bottom: 0;
    }
  }
}
</style>
